import {Input as AntdInput} from "antd";

const Input = ({type, disabled, placeholder, name, value, onChange, iconRender, className}) => {
    if (type === 'password') {
        return (<AntdInput.Password
                placeholder={placeholder}
                name={name}
                value={value}
                onChange={onChange}
                iconRender={iconRender}
                className={className}
                disabled={disabled}
            />);
    }

    return (<AntdInput
            disabled={disabled}
            className={className}
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
        />);
};

export default Input;